import { rm, combineReducers } from 'utils';
import { baseFormReducer, baseReducer, BaseAction, BaseInitialState, BaseState } from '../Utils';
import { SupportProductModel } from 'models/SupportProductModel';
import { isCustomerContactValid } from '../Components/CustomerContact/utils';

type InternalState = BaseState & {
  change: string;
  changeError?: string;
  products: SupportProductModel[];
  productsError?: string;
};

export const changesInitialState: InternalState = {
  ...BaseInitialState,
  change: '',
  products: []
};

type Action =
  | { type: 'change'; value: string }
  | { type: 'changeError'; value: string }
  | { type: 'productChanged'; value: SupportProductModel }
  | { type: 'productsError'; value: string }
  | BaseAction;

const changesReducer = (state: InternalState, action: Action): InternalState => {
  switch (action.type) {
    case 'productChanged':
      return { ...state, products: getProducts(action.value, state.products) };
    case 'productsError':
      return { ...state, productsError: action.value };
    case 'change':
      return { ...state, change: action.value };
    case 'changeError':
      return { ...state, changeError: action.value };
    default:
      return state;
  }
};

export const reducer = combineReducers<InternalState, Action>(
  baseFormReducer,
  baseReducer,
  changesReducer
);

const getProducts = (
  product: SupportProductModel,
  selectedProducts: SupportProductModel[]
): SupportProductModel[] => {
  if (selectedProducts.some(sp => sp.productId === product.productId)) {
    return selectedProducts.map(sp => {
      if (sp.productId === product.productId) {
        return { ...sp, quantity: product.quantity };
      }
      return sp;
    });
  }

  selectedProducts.push({
    productId: product.productId,
    productName: product.productName,
    productRecievedDate: product.productRecievedDate,
    quantity: product.quantity,
    unit: product.unit
  });

  return selectedProducts;
};

export const isValid = (state: InternalState, dispatch: (action: Action) => void) => {
  let isValid = true;

  if (state.products.length === 0) {
    dispatch({
      type: 'productsError',
      value: rm('customerpage_returns_validation_error_products')
    });
    isValid = false;
  }

  if (state.change === '') {
    dispatch({
      type: 'changeError',
      value: rm('customerpage_change_validation_error')
    });
    isValid = false;
  }
  isValid = isCustomerContactValid({ state, valid: isValid, dispatch });

  return isValid;
};

export const productChanged = (
  product: SupportProductModel,
  dispatch: (action: Action) => void
) => {
  dispatch({ type: 'productChanged', value: product });
  dispatch({ type: 'productsError', value: '' });
};
